import React from "react";
import PropTypes from "prop-types";
import {Chip} from "@mui/material";
import StyledAvatar from "../avatars/StyledAvatar";
import {useUser} from "../user/Context/UserProvider";
import {isString} from "underscore";
import {useChipStyles} from "./chipStyles";

const AvatarTextChip = ({text, image, isListItem = false, style}) => {
  if (!text || !isString(text)) {
    return null;
  }
  const {user} = useUser();
  const {classes} = useChipStyles({isListItem});
  const avatarImage = text === user?.email ? user?.profileDocumentPreview : image;
  const avatarSize = isListItem ? undefined : "small";

  return (
    <Chip
      label={text}
      avatar={
        <StyledAvatar text={text} image={avatarImage} size={avatarSize} showTooltip={false} />
      }
      size={avatarSize}
      className={classes.avatarTextChip}
      style={style}
    />
  );
};

AvatarTextChip.propTypes = {
  text: PropTypes.string.isRequired,
  image: PropTypes.string,
  isListItem: PropTypes.bool,
  style: PropTypes.object,
};

export default AvatarTextChip;
